import React from 'react'
import classnames from 'classnames'
import selectn from 'selectn'

const MatchNotes = ({
  noteGroups = []
}) => {
  
  const content = (
    <article className="sub-module cricket research-notes">
      <header className="bordered">
        <h1>Match Notes</h1>
      </header>
      <div className="content">
        <ul className="css-accordion">
          {
            noteGroups.map((n = {} , i) => {
          
              let notes = n.notes || []
              // Get day for which this match note is being shown
              let day = selectn('[0].day', notes) || 0
              // If day is 0, this match note needs to be shown under General heading
              let accordionHeader = n.title || ''
              let isExpanded = n.expanded
              let headerClass = isExpanded ? '' : 'collapsed'
              //console.info('isExpanded', isExpanded)

              return (
                <li key={i} className="accordion-item">
                {
                  notes.length > 0 &&
                  <div className="accordion-header">
                    <p>
                      <a role="button" data-toggle="collapse" href={'#accordion-0'+(day)} aria-expanded="false" aria-controls="accordion-01" className={headerClass}>{accordionHeader}</a>
                    </p>
                  </div>
                }
                  <div id={'accordion-0'+(day)} className={classnames('accordion-content collapse', { 'in' : isExpanded })} aria-expanded="false">
                    <div className="content">
                      <ul className="bulleted-list">
                       {
                          notes.length > 0 &&
                          notes.map((note = {}, j) => <li key={j} dangerouslySetInnerHTML={{ __html: note.text }}></li>)
                        }
                        {
                          notes.length === 0 &&
                          <li>{accordionHeader}</li>
                        }
                      </ul>
                    </div>
                  </div>
                </li>
              )
            })
          }
        </ul>
      </div>
    </article>
  )

  return noteGroups.length ? content : <article className="sub-module cricket research-notes" />
}

export default MatchNotes



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/MatchNotes.jsx
 **/